import { render, staticRenderFns } from "./special-table.vue?vue&type=template&id=94066e2a&scoped=true"
import script from "./special-table.vue?vue&type=script&lang=js"
export * from "./special-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94066e2a",
  null
  
)

export default component.exports